import { findBand, BAND_COLORS } from "../bands";

// BASDAI — Bath Ankylosing Spondylitis Disease Activity Index.
// Six 0–10 questions; a score >= 4 suggests active disease.
// ⚠️ Verify clinically before relying on results.
const basdaiBands = [
    { label: "Below threshold", color: BAND_COLORS.low, lt: 4 },
    { label: "Active disease (≥4)", color: BAND_COLORS.high },
];

export const basdai = {
    id: "basdai",
    name: "BASDAI",
    subtitle: "Bath ankylosing spondylitis disease activity index",
    group: "Axial spondyloarthritis",
    status: "ready",
    layout: "stacked",
    intro: "Answer the questions below relating to the past week.",
    options: [],
    fields: [
        {
            key: "q1",
            label: "Overall level of fatigue/tiredness you have experienced",            hint: "None: 0 · Very severe: 10",
            type: "number",
            min: 0,
            max: 10,
            step: 0.1,
        },
        {
            key: "q2",
            label: "Overall level of inflammatory neck, back or hip pain",            hint: "None: 0 · Very severe: 10",
            type: "number",
            min: 0,
            max: 10,
            step: 0.1,
        },
        {
            key: "q3",
            label: "Overall level of pain/swelling in joints other than neck, back or hips",            hint: "None: 0 · Very severe: 10",
            type: "number",
            min: 0,
            max: 10,
            step: 0.1,
        },
        {
            key: "q4",
            label: "Overall level of discomfort from any areas tender to touch or pressure",            hint: "None: 0 · Very severe: 10",
            type: "number",
            min: 0,
            max: 10,
            step: 0.1,
        },
        {
            key: "q5",
            label: "Overall level of morning stiffness from the time you wake up",            hint: "None: 0 · Very severe: 10",
            type: "number",
            min: 0,
            max: 10,
            step: 0.1,
        },
        {
            key: "q6",
            label: "How long your morning stiffness lasts from the time you wake up",            hint: "0 hrs: 0 · ½ hr: 2.5 · 1 hr: 5 · 1½ hr: 7.5 · ≥2 hrs: 10",
            type: "number",
            min: 0,
            max: 10,
            step: 0.5,
        },
    ],
    // Mean of Q1–Q4 with the two morning-stiffness questions (Q5, Q6) averaged first.
    compute: (v) => (v.q1 + v.q2 + v.q3 + v.q4 + (v.q5 + v.q6) / 2) / 5,
    interpret: (score) => findBand(score, basdaiBands),
    bands: () => basdaiBands,
    about:
        "The Bath Ankylosing Spondylitis Disease Activity Index (BASDAI) is a patient-reported measure of fatigue, spinal and peripheral pain, enthesitis, and morning stiffness (severity and duration) on 0–10 scales. The two morning-stiffness items are averaged before combining with the other four; a score of 4 or above generally indicates active disease.",
    references: [
        "Garrett S, et al. A new approach to defining disease status in ankylosing spondylitis: the BASDAI. J Rheumatol. 1994.",
    ],
};
